import { createFileRoute, Link, Outlet } from "@tanstack/react-router";
import { LogoBlack } from "~/components/logo";

export const Route = createFileRoute("/(auth)/_auth")({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex min-h-screen flex-col w-full overflow-hidden bg-[#F1F4F9] shadow-lg backdrop-blur-lg">
      <header
        className="sticky top-0 z-10 flex h-[110px] shrink-0 flex-col py-4 px-4 transition-[width,height] ease-linear sm:flex-row sm:items-center sm:justify-between sm:px-[32px] md:px-[32px]"
        role="header"
      >
        <Link to="/" className="flex items-center gap-2 px-4 sm:gap-4">
          <LogoBlack className="h-8 w-auto" />
        </Link>
      </header>
      <div className="flex items-center justify-center pt-[30px]">
        <Outlet />
      </div>
    </div>
  );
}
